import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appVersionInput]',
})
export class VersionInputDirective {
  inputElement: HTMLInputElement;
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste',
    '.',
  ];
  private regex = /^(\d+(\.\d+)?\.){0,2}(\d+(\.\d+)?)?$/;

  constructor(private el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (
      this.navigationKeys.indexOf(event.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      (event.key === 'a' && event.ctrlKey === true) || // Allow: Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) || // Allow: Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) || // Allow: Ctrl+V
      (event.key === 'x' && event.ctrlKey === true) || // Allow: Ctrl+X
      (event.key === 'a' && event.metaKey === true) || // Allow: Cmd+A (Mac)
      (event.key === 'c' && event.metaKey === true) || // Allow: Cmd+C (Mac)
      (event.key === 'v' && event.metaKey === true) || // Allow: Cmd+V (Mac)
      (event.key === 'x' && event.metaKey === true) // Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }
    if (!this.regex.test(event.key)) {
      event.preventDefault();
      return;
    }
  }

  @HostListener('input', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInput(e: InputEvent) {
    const regex = /^(\d+(\.\d+)?\.){0,2}(\d+(\.\d+)?)?$/;
    const value = this.inputElement.value;

    if (!regex.test(value)) {
      this.inputElement.value = value.substring(0, value.length - 1);
      if (!regex.test(this.inputElement.value)) {
        this.inputElement.value = this.inputElement.value.replace(/\D/g, '');
      }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData.getData('text/plain');
    if (!pastedInput.match(this.regex)) {
      event.preventDefault();
    }
  }
}
